/* eslint-disable react/no-array-index-key */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-shadow */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  getStringFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';

import {
  convertTravelTime,
  formatBookingDate,
  formatDate,
  formatTimeString,
  getBookingClassText,
  getConnectingTime,
  getNewDate,
  getOnlyTerminalNumber,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
} from '../../shared/constants/Constants';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppButton from '../../shared/components/app-button/AppButton';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { AIRLINE_NAMES_FOR_CARRIER_CODE } from '../../shared/constants/FlightCarrierNames';
import {
  APP_AGENT_LOGO_URL,
  APP_LOGO_URL,
} from '../../saas/AppStorageStaticNames';

function FlightPerPaxTicketModal({
  paxDetails,
  agentDetails,
  flightInvoice,
  onwardSectors,
  returnSectors,
  onDownload,
  fareSummary,
  //   imageValid,
}) {
  const { appConfig } = useAppContext();
  const paxDetailsRef = useRef(paxDetails);
  const agentDetailsRef = useRef(agentDetails);
  const flightInvoiceRef = useRef(flightInvoice);
  const onwardSectorRef = useRef(onwardSectors);
  const returnSectorRef = useRef(returnSectors);
  const [selectedPassenegers, setSelectedPassengers] = useState([]);
  const fareSummaryRef = useRef(fareSummary);
  const [showBreakup, setShowBreakup] = useState(true);
  const [showAgency, setShowAgency] = useState(true);

  const handlePaxSelection = (pax) => {
    setSelectedPassengers((prevItems) => {
      if (prevItems.some((selectedItem) => selectedItem.name === pax.name)) {
        return prevItems.filter(
          (selectedItem) => selectedItem.name !== pax.name,
        );
      }
      return [...prevItems, pax];
    });
  };
  const getCarrierImagePath = (carrier) => {
    const IMAGE_PATH = appConfig.appFlightCarrierImg;
    let carrierName = carrier;
    if (
      ['I5', 'IX', 'QP', 'G8', 'SG', '6E', 'S5', 'AI'].indexOf(carrier) > -1
    ) {
      carrierName = `${carrier}`;
    }
    return `${IMAGE_PATH}${carrierName}.jpg`;
  };

  const formatCurrency = (amount) => {
    if (!isEmpty(amount)) {
      let amtToDisplay = amount;
      if (selectedPassenegers.length > 0) {
        amtToDisplay =
          (amount * selectedPassenegers.length) / paxDetails.length;
      }
      return `INR ${amtToDisplay.toFixed(2)}`;
    }
    return '';
  };

  const isPaxSelected = (pax) => {
    if (selectedPassenegers.length > 0) {
      const present = selectedPassenegers.some((d) => d.name === pax.name);
      if (present) {
        return true;
      }
      return false;
    }
    return false;
  };

  const handlePerPaxTicketDownload = async () => {
    const htmlContent = document.getElementById('perpaxticket').innerHTML;
    onDownload(htmlContent);
  };

  const hasSSRForSelectedPax = () => {
    let hasSSR = false;
    if (!isEmpty(flightInvoice?.PassengerSSRRecords?.PassengerSSRRecord)) {
      const ssrRecords = Array.isArray(
        flightInvoice.PassengerSSRRecords.PassengerSSRRecord,
      )
        ? flightInvoice.PassengerSSRRecords.PassengerSSRRecord
        : [flightInvoice.PassengerSSRRecords.PassengerSSRRecord];
      selectedPassenegers.forEach((pax) => {
        ssrRecords.forEach((ssr) => {
          const name = `${ssr.Title} ${ssr.FirstName} ${ssr.LastName}`;
          if (name === pax.name) {
            hasSSR = true;
          }
        });
      });
    }
    return hasSSR;
  };

  const getSSRAmountForSelectedPax = (onlyAMount) => {
    try {
      if (!isEmpty(flightInvoice?.PassengerSSRRecords?.PassengerSSRRecord)) {
        const ssrRecords = Array.isArray(
          flightInvoice.PassengerSSRRecords.PassengerSSRRecord,
        )
          ? flightInvoice.PassengerSSRRecords.PassengerSSRRecord
          : [flightInvoice.PassengerSSRRecords.PassengerSSRRecord];
        let totalAmount = 0;
        selectedPassenegers.forEach((pax) => {
          ssrRecords.forEach((ssr) => {
            const name = `${ssr.Title} ${ssr.FirstName} ${ssr.LastName}`;
            if (!isEmpty(ssr.ChargeableAmount) && name === pax.name) {
              totalAmount += parseInt(ssr.ChargeableAmount, 10);
            }
          });
        });
        if (onlyAMount) {
          return parseInt(totalAmount, 10);
        }
        return `INR ${totalAmount}`;
      }
      if (onlyAMount) {
        return 0;
      }
      return 'INR 0';
    } catch (error) {
      return 0;
    }
  };

  const getTotalForSelectedPax = () => {
    if (selectedPassenegers.length > 0) {
      const totalFareQuotePerPaxWithAdditionalFare =
        ((flightInvoice.FlightRecord.FareQuoteAmount +
          flightInvoice.AdditionalMarkup) *
          selectedPassenegers.length) /
        paxDetails.length;
      const ssrAmount = getSSRAmountForSelectedPax(true);
      return formatCurrency(totalFareQuotePerPaxWithAdditionalFare + ssrAmount);
    }
    return 'INR 0';
  };

  return (
    <>
      <div className="d-flex flex-column gap-3">
        <div className="d-flex flex-column gap-1">
          {paxDetailsRef.current.map((pax, index) => (
            <AppCheckBox
              key={pax.name}
              onChange={() => handlePaxSelection(pax)}
              name="selectedPax"
              id={pax.name}
              labelText={pax.name}
              checked={isPaxSelected(pax)}
            />
          ))}
        </div>
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true_breakup"
            name="showBreakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false_breakup"
            name="showBreakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true_agency"
            name="showAgency"
            labelText="With Agency"
            value=""
            onChange={() => setShowAgency(true)}
            checked={showAgency}
          />
          <AppRadioInput
            id="false_agency"
            name="showAgency"
            labelText="Without Agency"
            value=""
            onChange={() => setShowAgency(false)}
            checked={!showAgency}
          />
        </div>
        <div className="d-flex justify-content-end">
          <AppButton
            btnText="Download"
            onClick={handlePerPaxTicketDownload}
            disabled={selectedPassenegers.length === 0}
          />
        </div>
      </div>
      <section
        style={{
          padding: '1rem 10px',
          width: '900px',
          marginInline: 'auto',
          pageBreakInside: 'avoid',
          fontFamily: 'Avenir Heavy, sans-serif',
        }}
        id="perpaxticket"
        className="print-page-break d-none"
      >
        <div id="ticketHeader" className="d-block">
          <div
            style={{
              padding: '8px',
              borderBottom: '1px solid #ccc',
              marginBottom: '10px',
            }}
            className="avoid-page-break-in-print"
          >
            <table
              style={{ width: '100%', borderSpacing: '0' }}
              className="avoid-page-break-in-print"
            >
              <tbody>
                <tr>
                  <td width="50%">
                    <div>
                      {showAgency ? (
                        <img
                          src={
                            getStringFromLS(APP_AGENT_LOGO_URL) ||
                            getStringFromLS(APP_LOGO_URL)
                          }
                          onError={(e) =>
                            (e.target.src = getStringFromLS(APP_LOGO_URL))
                          }
                          alt={appConfig.companyName}
                          height="80px"
                        />
                      ) : (
                        <div style={{ color: 'red' }} className="fs-20">
                          <div>Electronic Ticket</div>
                          <div>
                            {
                              flightInvoiceRef.current.FlightRecord
                                .BookingStatus
                            }
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                  <td width="50%">
                    <table
                      style={{
                        fontSize: '12px',
                        fontWeight: '500',
                        lineHeight: '16px',
                        borderSpacing: '0',
                        textAlign: 'end',
                        width: '100%',
                      }}
                      className="avoid-page-break-in-print"
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              color: 'red',
                              fontWeight: '600',
                            }}
                          >
                            <span>{agentDetailsRef.current.Company}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>{agentDetailsRef.current.Address1}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {`${agentDetailsRef.current.City}, ${agentDetailsRef.current.State}-${agentDetailsRef.current.PinCode}, ${agentDetailsRef.current.Country}`}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Phone Number :{' '}
                            {agentDetailsRef.current.ContactNumber}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Email Id : {agentDetailsRef.current.ContactEmail}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          style={{
            margin: '10px',
            borderRadius: '6px',
            overflow: 'hidden',
            fontSize: '14px',
            boxShadow: '0px 0px 10px 2px #0000001A',
          }}
          className="avoid-page-break-in-print"
        >
          <table
            style={{ width: '100%' }}
            className="avoid-page-break-in-print"
          >
            <thead
              style={{
                backgroundColor: `${appConfig?.clientPrimaryColor}`,
                color: '#fff',
              }}
            >
              <tr>
                <td colSpan={5} style={{ padding: '3px 16px' }}>
                  Booking Details [
                  {flightInvoiceRef.current.FlightRecord.BookingStatus}]
                </td>
              </tr>
            </thead>
            <tbody style={{ textAlign: 'center' }}>
              <tr>
                <td
                  style={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: '500',
                    padding: '5px',
                  }}
                >
                  Booking ID
                </td>
                <td
                  style={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: '500',
                    padding: '5px',
                    textAlign: 'center',
                  }}
                >
                  GDS PNR
                </td>
                <td
                  style={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: '500',
                    padding: '5px',
                    textAlign: 'center',
                  }}
                >
                  Airline PNR
                </td>
                <td
                  style={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: '500',
                    padding: '5px',
                    textAlign: 'center',
                  }}
                >
                  Booking Date
                </td>
              </tr>
              <tr>
                <td
                  style={{ color: '#666666', fontSize: '14px', padding: '5px' }}
                >
                  {flightInvoiceRef.current.FlightRecord.Txid}
                </td>
                <td
                  style={{ color: '#666666', fontSize: '14px', padding: '5px' }}
                >
                  {flightInvoiceRef.current.FlightRecord.GdsPnr}
                </td>
                <td
                  style={{ color: '#666666', fontSize: '14px', padding: '5px' }}
                >
                  {flightInvoiceRef.current.FlightRecord.AirlinePnr}
                </td>
                <td
                  style={{ color: '#666666', fontSize: '14px', padding: '5px' }}
                >
                  {formatBookingDate(
                    flightInvoiceRef.current.FlightRecord.BookingDate,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            backgroundColor: `${appConfig?.clientPrimaryColor}`,
            padding: '3px 16px',
            color: '#fff',
            margin: '10px',
            borderRadius: '6px',
            fontSize: '14px',
            overflow: 'hidden',
          }}
          className="avoid-page-break-in-print"
        >
          <table width="100%" className="avoid-page-break-in-print">
            <tbody>
              <tr>
                <td
                  style={{
                    textAlign: 'start',
                    width: '100%',
                    fontWeight: '500',
                    color: '#fff',
                  }}
                >
                  Flight Details
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{ fontSize: '12px', color: '#666666', margin: '10px' }}
          className="avoid-page-break-in-print"
        >
          Subject to prior sale, price and schedule changes. In large parts air
          fares can only be cancelled or rebooked for a fee. These fees may
          consist up to 100% of the air fare. Detailed conditions can be
          obtained from your travel agent or tour operator.
        </div>
        <div
          style={{
            fontSize: '11px',
            margin: '10px',
            borderRadius: '6px',
            overflow: 'hidden',
            color: '#666666',
            border: '1px solid #e2e2e2',
            fontWeight: '300',
          }}
          className="avoid-page-break-in-print"
        >
          <table width="100%" className="avoid-page-break-in-print">
            <tbody>
              <tr>
                <td
                  style={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: '600',
                    padding: '5px 16px',
                    fontSize: '13px',
                    color: '#333',
                    borderBottom: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    textAlign: 'start',
                  }}
                  colSpan={7}
                >
                  {flightInvoiceRef.current.FlightRecord.Origin} -{' '}
                  {flightInvoiceRef.current.FlightRecord.Destination}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    borderRight: '1px solid #e2e2e2',
                    width: '105px',
                    padding: '3px',
                  }}
                >
                  <div>Carrier /</div>
                  <div>Dep Date</div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    width: '80px',
                    padding: '3px',
                  }}
                >
                  <div>Flight No</div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    width: '225px',
                    padding: '3px',
                  }}
                >
                  <div>Departure /</div>
                  <div>Dep Terminal</div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    width: '225px',
                    padding: '3px',
                  }}
                >
                  <div>Arrival /</div>
                  <div>Arr Terminal</div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    width: '70px',
                    padding: '3px',
                  }}
                >
                  <div>Dep Time/</div>
                  <div>Dep Date</div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    borderRight: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    width: '70px',
                    padding: '3px',
                  }}
                >
                  <div>Arr Time/</div>
                  <div>Arr Date</div>
                </td>
                <td
                  style={{
                    borderBottom: '1px solid #e2e2e2',
                    color: '#000',
                    fontWeight: '500',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                  }}
                >
                  <div>Duration /</div>
                  <div>Cabin Class</div>
                </td>
              </tr>
              {onwardSectorRef.current.length > 0 &&
                onwardSectorRef.current.map((sector, index) => {
                  const finalDestination =
                    onwardSectorRef.current[onwardSectorRef.current.length - 1]
                      .Destination;
                  return (
                    <React.Fragment
                      key={`${sector.Origin}-${sector.Destination}`}
                    >
                      <tr>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            width: '105px',
                            borderRight: '1px solid #e2e2e2',
                          }}
                        >
                          <table className="avoid-page-break-in-print">
                            <tbody>
                              <tr>
                                <td>
                                  <img
                                    className="vertical-bottom"
                                    alt="Flight"
                                    src={getCarrierImagePath(
                                      sector.Carrier.substring(0, 2),
                                    )}
                                    style={{
                                      width: '25px',
                                      height: '25px',
                                      marginLeft: '5px',
                                    }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontSize: '11px' }}>
                                  {
                                    AIRLINE_NAMES_FOR_CARRIER_CODE[
                                      sector.Carrier.substring(0, 2)
                                    ]
                                  }
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontSize: '11px' }}>
                                  {formatDate(
                                    getNewDate(sector.JourneyDate),
                                    DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            width: '80px',
                            borderRight: '1px solid #e2e2e2',
                          }}
                        >
                          <div style={{ fontSize: '11px' }}>
                            {`${sector.Carrier}-${sector.FlightNumber}`}
                          </div>
                          <div style={{ fontSize: '11px' }}>
                            {/* Equipment: airbus-321 */}
                            {sector.Equipment === null
                              ? ''
                              : `Equipment: ${sector.Equipment} ${sector.FlightModel}`}
                          </div>
                        </td>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            width: '225px',
                            borderRight: '1px solid #e2e2e2',
                          }}
                        >
                          <table className="avoid-page-break-in-print">
                            <tbody>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {sector.OriginAirportFullname} (
                                  {sector.Origin})
                                </td>
                              </tr>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {getOnlyTerminalNumber(
                                    sector.AirportTerminal.split(',')[0],
                                  ) !== ''
                                    ? `Terminal: ${getOnlyTerminalNumber(
                                        sector.AirportTerminal.split(',')[0],
                                      )}`
                                    : ''}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            width: '225px',
                            borderRight: '1px solid #e2e2e2',
                          }}
                        >
                          <table className="avoid-page-break-in-print">
                            <tbody>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {sector.DestinationAirportFullname} (
                                  {sector.Destination})
                                </td>
                              </tr>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {getOnlyTerminalNumber(
                                    sector.AirportTerminal.split(',')[1],
                                  ) !== ''
                                    ? `Terminal: ${getOnlyTerminalNumber(
                                        sector.AirportTerminal.split(',')[1],
                                      )}`
                                    : ''}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            width: '70px',
                            borderRight: '1px solid #e2e2e2',
                          }}
                        >
                          <table className="avoid-page-break-in-print">
                            <tbody>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {formatTimeString(sector.DepartureTime)}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {formatDate(
                                    getNewDate(sector.JourneyDate),
                                    DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            width: '70px',
                            borderRight: '1px solid #e2e2e2',
                          }}
                        >
                          <table>
                            <tbody>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {formatTimeString(sector.ArrivalTime)}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ color: '#333', fontSize: '11px' }}>
                                  {formatDate(
                                    getNewDate(sector.ArrivalDate),
                                    DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            padding: '3px',
                            verticalAlign: 'top',
                            color: '#333',
                            fontSize: '11px',
                          }}
                        >
                          <div>{convertTravelTime(sector.SectorDuration)}</div>
                          <div>
                            {getBookingClassText(
                              flightInvoiceRef.current.FlightRecord.CabinClass,
                            )}
                          </div>
                        </td>
                      </tr>
                      {sector.Destination !== finalDestination && (
                        <tr>
                          <td
                            style={{
                              textAlign: 'center',
                              color: '#374471',
                              fontWeight: '500',
                              backgroundColor: '#fce5e6',
                              fontSize: '11px',
                            }}
                            colSpan="7"
                          >
                            {getConnectingTime(
                              sector.ArrivalTime,
                              sector.ArrivalDate,
                              onwardSectorRef.current[index + 1].DepartureTime,
                              onwardSectorRef.current[index + 1].JourneyDate,
                            )}{' '}
                            layover in {sector.Destination}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
        {returnSectorRef.current.length > 0 && (
          <div
            style={{
              fontSize: '11px',
              margin: '10px',
              borderRadius: '6px',
              overflow: 'hidden',
              color: '#666666',
              border: '1px solid #e2e2e2',
              fontWeight: '300',
            }}
            className="avoid-page-break-in-print"
          >
            <table width="100%" className="avoid-page-break-in-print">
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: '#f5f5f5',
                      fontWeight: '600',
                      padding: '5px 16px',
                      fontSize: '13px',
                      color: '#333',
                      borderBottom: '1px solid #e2e2e2',
                      borderRight: '1px solid #e2e2e2',
                      textAlign: 'start',
                    }}
                    colSpan={7}
                  >
                    {flightInvoiceRef.current.FlightRecord.Destination} -{' '}
                    {flightInvoiceRef.current.FlightRecord.Origin}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      borderRight: '1px solid #e2e2e2',
                      width: '105px',
                      padding: '3px',
                    }}
                  >
                    <div>Carrier /</div>
                    <div>Dep Date</div>
                  </td>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      borderRight: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      width: '80px',
                      padding: '3px',
                    }}
                  >
                    <div>Flight No</div>
                  </td>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      borderRight: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      width: '225px',
                      padding: '3px',
                    }}
                  >
                    <div>Departure /</div>
                    <div>Dep Terminal</div>
                  </td>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      borderRight: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      width: '225px',
                      padding: '3px',
                    }}
                  >
                    <div>Arrival /</div>
                    <div>Arr Terminal</div>
                  </td>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      borderRight: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      width: '70px',
                      padding: '3px',
                    }}
                  >
                    <div>Dep Time/</div>
                    <div>Dep Date</div>
                  </td>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      borderRight: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      width: '70px',
                      padding: '3px',
                    }}
                  >
                    <div>Arr Time/</div>
                    <div>Arr Date</div>
                  </td>
                  <td
                    style={{
                      borderBottom: '1px solid #e2e2e2',
                      color: '#000',
                      fontWeight: '500',
                      backgroundColor: '#f5f5f5',
                      padding: '3px',
                    }}
                  >
                    <div>Duration /</div>
                    <div>Cabin Class</div>
                  </td>
                </tr>
                {returnSectorRef.current.length > 0 &&
                  returnSectorRef.current.map((sector, index) => {
                    const finalDestination =
                      returnSectorRef.current[
                        returnSectorRef.current.length - 1
                      ].Destination;
                    return (
                      <React.Fragment
                        key={`${sector.Origin}-${sector.Destination}`}
                      >
                        <tr>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              width: '105px',
                              borderRight: '1px solid #e2e2e2',
                            }}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <img
                                      className="vertical-bottom"
                                      alt="Flight"
                                      src={getCarrierImagePath(
                                        sector.Carrier.substring(0, 2),
                                      )}
                                      style={{
                                        width: '25px',
                                        height: '25px',
                                        marginLeft: '5px',
                                      }}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ fontSize: '11px' }}>
                                    {
                                      AIRLINE_NAMES_FOR_CARRIER_CODE[
                                        sector.Carrier.substring(0, 2)
                                      ]
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ fontSize: '11px' }}>
                                    {formatDate(
                                      getNewDate(sector.JourneyDate),
                                      DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              width: '80px',
                              borderRight: '1px solid #e2e2e2',
                              fontSize: '11px',
                            }}
                          >
                            <div>
                              {`${sector.Carrier}-${sector.FlightNumber}`}
                            </div>
                            <div>
                              {sector.Equipment === null
                                ? ''
                                : `Equipment: ${sector.Equipment} ${sector.FlightModel}`}
                            </div>
                          </td>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              width: '225px',
                              borderRight: '1px solid #e2e2e2',
                            }}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {sector.OriginAirportFullname} (
                                    {sector.Origin})
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {getOnlyTerminalNumber(
                                      sector.AirportTerminal.split(',')[0],
                                    ) !== ''
                                      ? `Terminal: ${getOnlyTerminalNumber(
                                          sector.AirportTerminal.split(',')[0],
                                        )}`
                                      : ''}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              width: '225px',
                              borderRight: '1px solid #e2e2e2',
                            }}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {sector.DestinationAirportFullname} (
                                    {sector.Destination})
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {getOnlyTerminalNumber(
                                      sector.AirportTerminal.split(',')[1],
                                    ) !== ''
                                      ? `Terminal: ${getOnlyTerminalNumber(
                                          sector.AirportTerminal.split(',')[1],
                                        )}`
                                      : ''}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              width: '70px',
                              borderRight: '1px solid #e2e2e2',
                            }}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {formatTimeString(sector.DepartureTime)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {formatDate(
                                      getNewDate(sector.JourneyDate),
                                      DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              width: '70px',
                              borderRight: '1px solid #e2e2e2',
                            }}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {formatTimeString(sector.ArrivalTime)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{ color: '#333', fontSize: '11px' }}
                                  >
                                    {formatDate(
                                      getNewDate(sector.ArrivalDate),
                                      DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td
                            style={{
                              padding: '3px',
                              verticalAlign: 'top',
                              color: '#333',
                              fontSize: '11px',
                            }}
                          >
                            <div>
                              {convertTravelTime(sector.SectorDuration)}
                            </div>
                            <div>
                              {getBookingClassText(
                                flightInvoiceRef.current.FlightRecord
                                  .CabinClass,
                              )}
                            </div>
                          </td>
                        </tr>
                        {sector.Destination !== finalDestination && (
                          <tr>
                            <td
                              style={{
                                textAlign: 'center',
                                color: '#374471',
                                fontWeight: '500',
                                fontSize: '11px',
                                backgroundColor: '#fce5e6',
                              }}
                              colSpan="7"
                            >
                              {getConnectingTime(
                                sector.ArrivalTime,
                                sector.ArrivalDate,
                                returnSectorRef.current[index + 1]
                                  .DepartureTime,
                                returnSectorRef.current[index + 1].JourneyDate,
                              )}{' '}
                              layover in {sector.Destination}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
        <div
          style={{
            borderRadius: '6px',
            margin: '10px',
            overflow: 'hidden',
            border: '1px solid #e2e2e2',
          }}
          className="avoid-page-break-in-print"
        >
          <table width="100%" className="avoid-page-break-in-print">
            <thead>
              <tr>
                <td
                  style={{
                    backgroundColor: `${appConfig?.clientPrimaryColor}`,
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '3px 16px',
                  }}
                >
                  Passenger Details
                </td>
              </tr>
            </thead>
          </table>
          <table
            style={{
              width: '100%',
              fontSize: '11px',
              borderSpacing: '0',
            }}
            className="avoid-page-break-in-print"
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                    width: '200px',
                  }}
                >
                  Guest Name
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                    width: '70px',
                  }}
                >
                  Type
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                    width: '70px',
                  }}
                >
                  Sector
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                  }}
                >
                  Ticket Number
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                  }}
                >
                  FFN Number
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                  }}
                >
                  Baggage
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                  }}
                >
                  2D BARCODE
                </th>
                <th
                  style={{
                    border: '1px solid #e2e2e2',
                    backgroundColor: '#f5f5f5',
                    padding: '3px',
                    fontWeight: '500',
                  }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody
              style={{ fontSize: '11px', color: '#333', fontWeight: '300' }}
            >
              {selectedPassenegers.length > 0 &&
                selectedPassenegers.map((pax) => (
                  <tr key={pax.name}>
                    <td
                      style={{
                        border: '1px solid #e2e2e2',
                        textTransform: 'uppercase',
                      }}
                    >
                      {pax.name} <br />
                      {!isEmpty(pax.passport) && (
                        <>
                          <span style={{ fontSize: '10px', color: '#666' }}>
                            Passport:{' '}
                            <span style={{ fontSize: '11px' }}>
                              {pax.passport}
                            </span>
                          </span>
                          <br />
                        </>
                      )}
                      {!isEmpty(pax.dob) && (
                        <>
                          <span style={{ fontSize: '10px', color: '#666' }}>
                            DOB:{' '}
                            <span style={{ fontSize: '11px' }}>
                              {!isEmpty(pax.dob) &&
                                formatDate(
                                  getNewDate(pax.dob),
                                  DATE_MONTH_YEAR_VIEW_FORMAT,
                                )}
                            </span>
                          </span>
                          <br />
                        </>
                      )}
                      {!isEmpty(pax.passportExpiry) && (
                        <span style={{ fontSize: '10px', color: '#666' }}>
                          DOE:{' '}
                          <span style={{ fontSize: '11px' }}>
                            {!isEmpty(pax.passportExpiry) &&
                              formatDate(
                                getNewDate(pax.passportExpiry),
                                DATE_MONTH_YEAR_VIEW_FORMAT,
                              )}
                          </span>
                        </span>
                      )}
                    </td>
                    <td
                      style={{
                        border: '1px solid #e2e2e2',
                        textTransform: 'capitalize',
                      }}
                    >
                      {pax.paxType}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '0' }}>
                      {pax.paxSectors.length > 0 && (
                        <table style={{ width: '100%', borderSpacing: '0' }}>
                          <tbody>
                            {pax.paxSectors.map((paxsector, index) => (
                              <tr key={index}>
                                <td
                                  height="66px"
                                  style={{
                                    fontSize: '11px',
                                    borderBottom:
                                      pax.paxSectors.length - 1 !== index
                                        ? '1px solid #e2e2e2'
                                        : 'none',
                                  }}
                                >
                                  {paxsector.sectorInfo}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2' }}>
                      {pax.paxJourney.length > 0 && (
                        <table style={{ width: '100%', borderSpacing: '0' }}>
                          <tbody>
                            {pax.paxJourney.map((journey, index) => (
                              <tr key={index}>
                                <td
                                  height={
                                    index === 0
                                      ? `${pax.onwardsectorsLength * 66}px`
                                      : `${pax.returnsectorsLength * 66}px`
                                  }
                                  style={{
                                    fontSize: '11px',
                                    borderBottom:
                                      pax.paxJourney.length - 1 !== index
                                        ? '1px solid #e2e2e2'
                                        : 'none',
                                  }}
                                >
                                  {journey.journeyTicket}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </td>
                    <td
                      style={{
                        border: '1px solid #e2e2e2',
                        paddingInline: '0',
                      }}
                    >
                      {pax.paxSectors.length > 0 && (
                        <table
                          style={{ width: '100%', borderSpacing: '0' }}
                          className="avoid-page-break-in-print"
                        >
                          <tbody>
                            {pax.paxSectors.map((paxsector, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    fontSize: '11px',
                                    height: '66px',
                                    borderBottom:
                                      pax.paxSectors.length - 1 !== index
                                        ? '1px solid #e2e2e2'
                                        : 'none',
                                  }}
                                >
                                  {paxsector.sectorFFN}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2', padding: '0' }}>
                      {pax.paxSectors.length > 0 && (
                        <table style={{ width: '100%', borderSpacing: '0' }}>
                          <tbody>
                            {pax.paxSectors.map((paxsector, index) => (
                              <tr key={index}>
                                <td
                                  height="66px"
                                  style={{
                                    fontSize: '11px',
                                    borderBottom:
                                      pax.paxSectors.length - 1 !== index
                                        ? '1px solid #e2e2e2'
                                        : 'none',
                                  }}
                                >
                                  {pax.paxType.toLowerCase() === 'infant'
                                    ? ''
                                    : paxsector.sectorBaggage.split(',')[0]}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </td>
                    <td
                      style={{
                        border: '1px solid #e2e2e2',
                        paddingInline: '0',
                      }}
                    >
                      {pax.paxSectors.length > 0 && (
                        <table
                          style={{ width: '100%', borderSpacing: '0' }}
                          className="avoid-page-break-in-print"
                        >
                          <tbody>
                            {pax.paxSectors.map((paxsector, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    fontSize: '11px',
                                    height: '66px',
                                    borderBottom:
                                      pax.paxSectors.length - 1 !== index
                                        ? '1px solid #e2e2e2'
                                        : 'none',
                                  }}
                                >
                                  <img
                                    src={`${
                                      appConfig?.appMainUrl
                                    }${paxsector.sectorBarcode.substring(1)}`}
                                    alt=""
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </td>
                    <td style={{ border: '1px solid #e2e2e2' }}>
                      {pax.paxJourney.length > 0 && (
                        <table
                          style={{ width: '100%', borderSpacing: '0' }}
                          className="avoid-page-break-in-print"
                        >
                          <tbody>
                            {pax.paxJourney.map((journey, index) => (
                              <tr key={index}>
                                <td
                                  height={
                                    index === 0
                                      ? `${pax.onwardsectorsLength * 66}px`
                                      : `${pax.returnsectorsLength * 66}px`
                                  }
                                  style={{
                                    fontSize: '11px',
                                    borderBottom:
                                      pax.paxJourney.length - 1 !== index
                                        ? '1px solid #e2e2e2'
                                        : 'none',
                                  }}
                                >
                                  {journey.journeyStatus}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {hasSSRForSelectedPax() && (
          <div
            style={{
              border: '1px solid #e2e2e2',
              borderRadius: '6px',
              overflow: 'hidden',
              margin: '10px',
            }}
            className="avoid-page-break-in-print"
          >
            <table width="100%" className="avoid-page-break-in-print">
              <tr>
                <td
                  style={{
                    backgroundColor: '#646464',
                    padding: '3px 16px',
                    color: '#fff',
                    fontSize: '13px',
                    fontWeight: '600',
                  }}
                >
                  Passenger SSR Details
                </td>
              </tr>
            </table>
            <table
              style={{
                width: '100%',
                fontSize: '12px',
                borderSpacing: '0',
              }}
              className="avoid-page-break-in-print"
            >
              <thead style={{ fontSize: '11px', backgroundColor: '#f5f5f5' }}>
                <tr>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      padding: '3px',
                      width: '200px',
                    }}
                  >
                    Guest Name
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      padding: '3px',
                      width: '70px',
                    }}
                  >
                    Sector
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      padding: '3px',
                      width: '70px',
                    }}
                  >
                    Seat No
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      padding: '3px',
                    }}
                  >
                    Meal
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      padding: '3px',
                    }}
                  >
                    Excess Baggage
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      padding: '3px',
                      width: '70px',
                    }}
                  >
                    Other SSr
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '11px', fontWeight: '300' }}>
                {selectedPassenegers.length > 0 &&
                  selectedPassenegers.map((pax) => (
                    <tr key={pax.name}>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          textTransform: 'uppercase',
                        }}
                      >
                        {pax.name}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          padding: '3px',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={paxsector.sectorInfo}>
                                  <td
                                    style={{
                                      fontSize: '11px',
                                      borderBottom:
                                        pax.paxSectors.length - 1 !== index
                                          ? '1px solid #e2e2e2'
                                          : 'none',
                                    }}
                                  >
                                    {paxsector.sectorInfo}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          padding: '3px',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={paxsector.sectorInfo}>
                                  {paxsector.sectorSSr[0].length > 0 && (
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        borderBottom:
                                          pax.paxSectors.length - 1 !== index
                                            ? '1px solid #e2e2e2'
                                            : 'none',
                                      }}
                                    >
                                      {paxsector.sectorSSr[0].join(',')}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          padding: '3px',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={paxsector.sectorInfo}>
                                  {paxsector.sectorSSr[1].length > 0 && (
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        borderBottom:
                                          pax.paxSectors.length - 1 !== index
                                            ? '1px solid #e2e2e2'
                                            : 'none',
                                      }}
                                    >
                                      {paxsector.sectorSSr[1].join(',')}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          padding: '3px',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={paxsector.sectorInfo}>
                                  {paxsector.sectorSSr[2].length > 0 && (
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        borderBottom:
                                          pax.paxSectors.length - 1 !== index
                                            ? '1px solid #e2e2e2'
                                            : 'none',
                                      }}
                                    >
                                      {paxsector.sectorSSr[2].join(',')}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                      <td
                        style={{
                          border: '1px solid #e2e2e2',
                          padding: '3px',
                        }}
                      >
                        {pax.paxSectors.length > 0 && (
                          <table style={{ width: '100%', borderSpacing: '0' }}>
                            <tbody>
                              {pax.paxSectors.map((paxsector, index) => (
                                <tr key={paxsector.sectorInfo}>
                                  {paxsector.sectorSSr[3].length > 0 && (
                                    <td
                                      style={{
                                        fontSize: '11px',
                                        borderBottom:
                                          pax.paxSectors.length - 1 !== index
                                            ? '1px solid #e2e2e2'
                                            : 'none',
                                      }}
                                    >
                                      {paxsector.sectorSSr[3].join(',')}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        {showBreakup && (
          <div
            style={{
              margin: '10px',
              borderRadius: '6px',
              overflow: 'hidden',
              border: '1px solid #e2e2e2',
            }}
            className="avoid-page-break-in-print"
          >
            <table width="100%" className="avoid-page-break-in-print">
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: `${appConfig?.clientPrimaryColor}`,
                      color: '#fff',
                      fontSize: '13px',
                      fontWeight: '600',
                      padding: '3px 16px',
                    }}
                  >
                    Fare Details
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                width: '100%',
                fontSize: '11px',
                borderSpacing: '0',
              }}
              className="avoid-page-break-in-print"
            >
              <thead style={{ backgroundColor: '#f5f5f5', fontWeight: '500' }}>
                <tr>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    Base Fare
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    K3 TAX
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    Taxes & Surcharge
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    Add On Charges
                  </th>
                  <th
                    style={{
                      border: '1px solid #e2e2e2',
                      fontWeight: '500',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    Total Paid
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontWeight: '300', color: '#666' }}>
                <tr>
                  <td
                    style={{
                      border: '1px solid #e2e2e2',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    {formatCurrency(fareSummaryRef.current.baseFare)}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e2e2e2',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    {formatCurrency(fareSummaryRef.current.kvalue)}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e2e2e2',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    {formatCurrency(
                      fareSummaryRef.current.otherTaxes +
                        flightInvoice.AdditionalMarkup +
                        fareSummaryRef.current.gst,
                    )}{' '}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e2e2e2',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    {getSSRAmountForSelectedPax()}
                  </td>
                  <td
                    style={{
                      border: '1px solid #e2e2e2',
                      fontSize: '11px',
                      padding: '3px',
                    }}
                  >
                    {getTotalForSelectedPax()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        <div
          style={{ margin: '10px', fontSize: '12px' }}
          className="avoid-page-break-in-print"
        >
          You have been informed that you have to carry valid identity papers
          (passport, ID, visa) in accordance with the immigration regulations of
          your destination and transfer countries. A travel cancelation and
          health insurance was offered to you and you have been informed to
          consider international formalities (vaccinations, customs, etc.). You
          accept the general conditions of carriage of the responsible carriers.
          You have been informed about the applicable fare rules (cancelation,
          rebooking, etc.). The data submitted for your booking will be stored
          electronically in order to assure correct processing and customer care
          for your journey. Service fees remain non refundable in case of
          cancelation. Please check your itinerary for schedule changes 72h
          prior to each flight on
        </div>
      </section>
    </>
  );
}

FlightPerPaxTicketModal.propTypes = {
  paxDetails: PropTypes.array.isRequired,
  agentDetails: PropTypes.any.isRequired,
  flightInvoice: PropTypes.any.isRequired,
  onwardSectors: PropTypes.any.isRequired,
  returnSectors: PropTypes.any.isRequired,
  fareSummary: PropTypes.any.isRequired,
  onDownload: PropTypes.any.isRequired,
  //   imageValid: PropTypes.bool.isRequired,
};

export default FlightPerPaxTicketModal;
